import { Fade, Grid } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import PermissionHide from 'components/PermissionHide';
import { enums } from 'helpers';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { savePageLoad } from 'store/Orbita/Healthcheck/actions';
import EliteCard from 'v2/components/Pages/Dashboard/EliteCard';
import LineChart from 'v2/components/Pages/Dashboard/LineChart';
import { steps } from 'v2/components/Pages/Dashboard/tour';
import AlumyWarning from 'v2/components/Shared/AlumyWarning';
import Banner from 'v2/components/Shared/Banner';
import BlackFriday from 'v2/components/Shared/BlackFriday';
import BlacklistMessage from 'v2/components/Shared/BlacklistMessage';
import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';
import GlobalWarning from 'v2/components/Shared/GlobalWarning';
import ModalBelt from 'v2/components/Shared/ModalBelt';
import ModalFidc from 'v2/components/Shared/ModalFidc';
import { ModalNews } from 'v2/components/Shared/ModalNews';
import ModalOwnership from 'v2/components/Shared/ModalOwnership';
import { ModalTerms } from 'v2/components/Shared/ModalTerms';
import PlgAnticipation from 'v2/components/Shared/PlgAnticipation';
import Tour from 'v2/components/Shared/Tour';
import Transfer from 'v2/components/Shared/Transfer';

import BarChart from './components/BarChart';
import CardTransferPJ from './components/CardTransferPJ';
import DoughnutChart from './components/DoughnutChart';
import News from './components/News';
import { QualificationValidation } from './components/QualificationValidation';
import SolucxNps from './components/SolucxNps';
import Wallet from './components/Wallet';
import { Consultancy } from './components/Wallet/Consultancy';
import styles from './styles';

import type User from 'classes/User';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends StyledComponentProps, RouteComponentProps {
  isCompletedWithAccess: boolean;
  isCompletedWithoutAccess: boolean;
  savePageLoad: typeof savePageLoad;
  currentUser: User;
  accountUser: User;
}

interface IState {
  canAccess?: boolean;
}

class Dashboard extends Component<IProps, IState> {
  private pageLoad = {
    startTime: 0,
    completed: false,
  };

  constructor(props: any) {
    super(props);
    this.pageLoad.startTime = performance.now();

    this.state = { canAccess: undefined };
    const accountUser = props.accountUser;

    if (accountUser?.acceptence_terms && !accountUser?.producer && !accountUser?.coproducer && !accountUser?.affiliate) {
      this.props.history.push('/producer/quickstart');
    }
  }

  componentDidUpdate() {
    const { isCompletedWithAccess, isCompletedWithoutAccess } = this.props;
    const { canAccess } = this.state;

    if (canAccess === undefined || this.pageLoad.completed) {
      return;
    }

    const isCompleted = canAccess ? isCompletedWithAccess : isCompletedWithoutAccess;

    if (isCompleted) {
      this.pageLoad.completed = true;
      this.props.savePageLoad('Dashboard', performance.now() - this.pageLoad.startTime);
    }
  }

  getAccountCurrency = () => {
    const currency = enums.ACCOUNT_CURRENCY[parseInt(localStorage.getItem('account_currency'))];
    return currency ? currency : 'BRL';
  };

  render() {
    const { currentUser, classes } = this.props;

    return (
      <>
        <h1 className={classes.title}>Resumo</h1>
        <Fade in={true} timeout={500}>
          <>
            {!!currentUser && !currentUser.is_support && <SolucxNps />}
            <UserGreetings />

            <PermissionHide action='myeduzz:dashboard:visualizar'>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <LineChart />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <EliteCard />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <div className={classes.walletContainer}>
                    <Consultancy />
                    {this.props.currentUser?.show_legal_person_card && this.props.currentUser?.type === 'J' && !this.props.currentUser.crossborder ? (
                      <CardTransferPJ user={this.props.currentUser} />
                    ) : this.props.currentUser?.crossborder ? (
                      <Transfer />
                    ) : (
                      <Wallet />
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <DoughnutChart id='best-sellers-chart' />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <BarChart id='recent-earnings-chart' />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <News />
                </Grid>
              </Grid>
            </PermissionHide>

            <PermissionHide inverse action='myeduzz:dashboard:visualizar'>
              <News />
            </PermissionHide>
          </>
        </Fade>
        <QualificationValidation />
      </>
    );
  }
}

function mapStateToPros(state: any) {
  return {
    isCompletedWithAccess:
      state.orbita.Dashboard.lastGain.isFetching === false &&
      state.orbita.Financial.loadAvailable.isFetching === false &&
      state.orbita.Dashboard.bestsellers.isFetching === false &&
      state.orbita.Dashboard.periodSalesGain.isFetching === false &&
      Array.isArray(state.orbita.Dashboard.listNewzz),
    isCompletedWithoutAccess: Array.isArray(state.orbita.Dashboard.listNewzz),
    currentUser: state.orbita.User.originalUser,
    accountUser: state.orbita.User.user,
  };
}

const UserGreetings = () => {
  return (
    <>
      <BlacklistMessage />
      <ModalTerms />
      <BlackFriday />
      <PlgAnticipation page='dashboard' />
      <Tour steps={steps} name='first_tour' />
      <ModalNews />
      <ModalOwnership />
      <ModalFidc />
      <ModalBelt />
      <GlobalWarning />
      <AlumyWarning />
      <ChargebackAlert />
      <Banner />
    </>
  );
};

export default styles(connect(mapStateToPros, { savePageLoad })(Dashboard));
